/**
 * Stable machine codes for every failure authorizeCredentials can throw,
 * mapped to the user-facing copy from the sign-in designs (Figma: KehillaHQ /
 * Sign-In & Password Reset). NextAuth transports thrown Error messages to the
 * client verbatim, so the server throws these codes and the login page maps
 * them to copy with authErrorMessage().
 *
 * Client-safe on purpose (no server-only import): the login page needs it.
 */
export const AUTH_ERRORS = {
    // One message for unknown email AND wrong password — the login form must
    // not be an email-existence oracle (it would defeat forgot-password's
    // uniform reply).
    INVALID_CREDENTIALS:
        "We couldn't sign you in. Please check your email and password, then try again.",
    // "15 minutes" matches the login limiter window in src/lib/ratelimit.ts.
    RATE_LIMITED:
        "For your security, we've paused sign-in after several attempts. Please wait about 15 minutes, or reset your password.",
    ACCOUNT_DEACTIVATED:
        'This account has been deactivated. Contact your congregation administrator.',
    MISSING_CREDENTIALS: 'Please enter your email and password.',
} as const

export type AuthErrorCode = keyof typeof AUTH_ERRORS

export const GENERIC_AUTH_ERROR_MESSAGE = 'Something went wrong. Please try again.'

export function isAuthErrorCode(code: unknown): code is AuthErrorCode {
    return typeof code === 'string' && code in AUTH_ERRORS
}

/** Map a NextAuth error string to copy; anything unrecognized gets the generic line. */
export function authErrorMessage(code: string | null | undefined): string {
    return isAuthErrorCode(code) ? AUTH_ERRORS[code] : GENERIC_AUTH_ERROR_MESSAGE
}
